/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Contract_Terms_HintInputs */



/**
* | output |
* | --- |
* | "Check these carefully. You can correct them until oneAI approves the contract; after that, only oneAI can change them." |
*
* @param {Partner_Add_Contract_Terms_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_contract_terms_hint = /** @type {((inputs?: Partner_Add_Contract_Terms_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Contract_Terms_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie diese sorgfältig. Bis zur Freigabe durch oneAI können Sie sie korrigieren, danach nur noch oneAI.")
	return /** @type {LocalizedString} */ ("Check these carefully. You can correct them until oneAI approves the contract; after that, only oneAI can change them.")
});